import { translateBackend } from '@assets/i18n/config';
import type { TranslatedString } from '@interfaces/shared';
import type { ModelOption } from './portfolioFilters';

export type { ModelOption };

export const MODEL_SEARCH_PER_PAGE = 50;

type ModelPortfolioRow = {
  id: string;
  name: string;
  translatedName?: TranslatedString | null;
  state?: string | null;
};

/** Variables for `fetchModelPortfolios` model-filter search. */
export function buildFetchModelPortfoliosSearchVariables(
  organizationId: string,
  query: string,
) {
  return {
    input: {
      filter: {
        organizationId,
        searchText: query,
      },
      pagination: { perPage: MODEL_SEARCH_PER_PAGE },
    },
  };
}

/** Maps `fetchModelPortfolios` hits into Autocomplete options. */
export function mapModelPortfolioSearchHits(
  rows: readonly ModelPortfolioRow[] | null | undefined,
): ModelOption[] {
  return (rows ?? [])
    .filter((row) => row.state !== 'INACTIVE')
    .map((row) => ({
      id: row.id,
      name: translateBackend(row.translatedName) || row.name,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

/** Keeps selected models visible when they are not in the latest search page. */
export function pinSelectedModelOptions(
  results: ModelOption[],
  selectedModelIds: string[],
  selectedModelNames: Record<string, string>,
): ModelOption[] {
  const pinned: ModelOption[] = [];
  for (const id of selectedModelIds) {
    if (!results.some((option) => option.id === id)) {
      pinned.push({
        id,
        name: selectedModelNames[id] || id,
      });
    }
  }
  if (pinned.length === 0) return results;
  return [...pinned, ...results];
}
